<template>
  <f7-page class="no-padding">
    <!-- <div v-if="loaded" class="tableContainer">
      <GisGeoJsonMap :name-map="'map'" :tree-locations="geometries" />
      <SummaryGroupedList :geometries-data="geometries" />
    </div> -->
    <!-- PRELOADER VISUAL NO BLOQUEANTE -->
    <!-- <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader />
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div> -->
    <div class="card-wrapper">
      <!-- Submenú en la parte superior del card -->
      <div class="sub-menu-wrapper">
        <SubMenu
          :items="MenuOptions.contexts.samples.itemsByArea.agronomy"
        />
      </div>

      <!-- Loader DevExtreme (igual que Sample Query) -->
      <DxLoadPanel
        :visible="!loaded"
        :show-pane="true"
        :show-indicator="true"
        :shading="false"
        :message="$t('loading')"
        :position="{ of: '.card-wrapper' }"
      />

      <div v-if="loaded" class="summary-sidebar-header">
        <div class="summary-title-icon"></div>
        <span class="summary-title-text">{{
          $t('advancedServices')
        }}</span>
      </div>

      <div v-if="loaded" class="advanced-services-layout">
        <div class="sidebar">
          <SummaryGroupedList :geometries-data="geometries" />
        </div>

        <div class="map-area">
          <GisGeoJsonMap
            :name-map="'map'"
            :tree-locations="geometries"
          />
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import { mapActions } from 'vuex';
import GisGeoJsonMap from '@/components/Gis/GeoJsonMap/index.vue';
import SummaryGroupedList from '@/components/Agronomy/AdvancedServices/SummaryGroupedList/index.vue';
import EventBus from '@/services/event-bus';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import MenuOptions from '@/json/menuOptions.json';
import SubMenu from '@/components/SubMenu/index.vue';
import DxLoadPanel from 'devextreme-vue/load-panel';

export default {
  name: 'AdvancedServicesPage',
  components: { GisGeoJsonMap, SummaryGroupedList, SubMenu, DxLoadPanel },
  data() {
    return {
      loaded: false,
      geometries: [],
      MenuOptions,
    };
  },
  async beforeMount() {
    // this.$f7.preloader.show();
    this.loaded = false;

    this.setRedirectedFromSamePage(false);

    this.setCurrentRoute([
      {
        name: this.$t('Agronomy'),
        disabled: false,
        page: 'AgronomySamplesPage',
        active: false,
      },
      {
        name: this.$t('advancedServices'),
        disabled: true,
        page: 'AgronomySamplesPage',
        active: true,
      },
    ]);
    this.setCurrentFilter('advancedServices');
    this.setIsEditingFarm(false);
    this.setIsCreatingParcel(false);
    this.setIsRecreatingParcel(false);
    this.setParcelIndex(0);
    this.setTempParcelGeoFeatures([]);
    this.clearGeoJsonPoints();
    this.resetCurrentGeoFeature();
    this.resetCentroide();

    try {
      this.geometries = await this.getFarmsGeometries();

      EventBus.$on('AdvancedServicesPage', async (params) => {
        // this.$f7.preloader.show();
        this.loaded = false;

        if (!params) {
          this.geometries = await this.getFarmsGeometries();
        } else {
          this.geometries = await this.getFarmsGeometriesWithFilters(
            params
          );
        }

        const farms = await this.getFarms(false);
        this.addSamplingDateToGeoFeatures(farms);

        this.loaded = true;
       // this.$f7.preloader.hide();
      });

      const farms = await this.getFarms(false);
      this.addSamplingDateToGeoFeatures(farms);
    } catch (e) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(e.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
      // this.$f7.preloader.hide();
    }
  },
  beforeDestroy() {
    EventBus.$off('AdvancedServicesPage');
  },
  methods: {
    addSamplingDateToGeoFeatures(farms) {
      this.geometries = this.geometries.map((geometry) => {
        const foundFarm = farms.find(
          (farm) =>
            farm.name ===
            geometry.geo_feature.features[0].properties.farm
        );

        if (foundFarm) {
          geometry.geo_feature.features[0].properties.sampling_date =
            foundFarm.sampling_date;
        }

        return geometry;
      });
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('filter', ['setCurrentFilter']),
    ...mapActions('gis', [
      'getFarmsGeometries',
      'getFarmsGeometriesWithFilters',
      'getFarms',
      'clearGeoJsonPoints',
    ]),
    ...mapActions('gisEditor', [
      'resetParcelGeoFeature',
      'setTempParcelGeoFeatures',
      'resetCurrentGeoFeature',
      'resetCentroide',
      'setParcelIndex',
    ]),
    ...mapActions('registerFarm', [
      'setIsEditingFarm',
      'setIsCreatingParcel',
      'getParcelServices',
      'setIsRecreatingParcel',
    ]),
    ...mapActions('nutritionalFollowing', [
      'setRedirectedFromSamePage',
    ]),
  },
};
</script>
<style>
.card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 28px;
  padding: 24px;
  padding-top: 18px !important;
  width: 100%;
  height: 80vh;
  background: var(--basic-white, #fff);
  border-radius: 10px;
  box-shadow: 0 1px 4px 0 rgba(87, 84, 95, 0.3);
  box-sizing: border-box;
  overflow: hidden;
}

/* Mantiene el layout original */
.advanced-services-layout {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
  height: auto;
}

/* Sidebar */
.sidebar {
  width: 400px;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 16px 16px 0 16px;
  border-radius: 10px;
  background: var(--Neutral-10, #f7f7f8);
  overflow-y: auto;
  height: auto;
  z-index: 2;
  margin-right: 24px;
}

/* Mapa */
.map-area {
  flex-grow: 1;
  height: auto;
  position: relative;
  z-index: 1;
}

/* Sin padding externo */
.f7-page.no-padding {
  padding: 0 !important;
}

.summary-sidebar-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.summary-title-icon {
  width: 25px;
  height: 25px;
  background-image: url('@/static/icons/mapa.svg');
  background-repeat: no-repeat;
  background-size: contain;
  margin-right: 10px;
}

.summary-title-text {
  font-weight: bold;
  font-size: 20px;
  color: #04509F;
}

.sub-menu-wrapper {
  width: 100%;
}
</style>
